import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PendingState {
  ids: Record<string, true>;
}

const initialState: PendingState = { ids: {} };

const commentsPendingSlice = createSlice({
  name: "commentsPending",
  initialState,
  reducers: {
    setPending: (state, action: PayloadAction<string>) => {
      state.ids[action.payload] = true;
    },
    clearPending: (state, action: PayloadAction<string>) => {
      delete state.ids[action.payload];
    },
  },
});

export const { setPending, clearPending } = commentsPendingSlice.actions;

export default commentsPendingSlice.reducer;
